import { styled } from '@mui/material/styles';
import { useTheme, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { atom, useSetAtom } from 'jotai';

const Wrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 0.3rem;
`;

const InnerWrapper = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(45deg, #ac8eff 0%, #51b7d8 100%);
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.22);
  border-radius: 4px;
  padding: 0.3rem;
  cursor: pointer;
`;

export const isDealFormOpenState = atom(false);

export const AddDealButton = () => {
  const { secondary } = useTheme().colors;
  const openDealForm2 = useSetAtom(isDealFormOpenState);

  return (
    <Wrapper>
      <InnerWrapper onClick={() => openDealForm2(true)}>
        <AddIcon />
      </InnerWrapper>
      <Typography variant={'caption2'} color={secondary['10']}>
        Add
      </Typography>
    </Wrapper>
  );
};
